export default {
  AUTO_JOIN_GREENROOM: 'autoJoinGreenroom',
  CAMERA_FQN: 'cameraFqn',
  CAMERA_MAX_RESOLUTION: 'cameraMaxResolution',
  ECHO_CANCELLATION: 'echoCancellation',
  MICROPHONE_FQN: 'microphoneFqn',
  MIGRATION_DATE: 'migrationDate',
  MIRROR_LOCAL_CAMERAS: 'mirrorLocalCameras',
  NOISE_SUPPRESSION: 'noiseSuppression',
  SHOW_GUIDES: 'showGuides',
  SHOW_HEALTH: 'showHealth',
  SPEAKER_FQN: 'speakerFqn',
  VIRTUAL_BACKGROUND: 'virtualBackground',
};
